<template>
  <div class="a-toggle-primary">
    <label :class="`a-toggle-switch-primary ${switchClass}`">
      <input
        :checked="value"
        v-bind="$attrs"
        @change="updateValue"
      >
      <span :class="`a-toggle-slider-primary ${sliderClass}`"></span>
      <span
        v-if="text.length"
        class="a-toggle-text-primary">
          {{ text }}
      </span>
    </label>
  </div>
</template>

<script>
export default {
  name: 'AtomTogglePrimary',
  inheritAttrs: false,

  props: {
    elementId: [Number, String],
    method: String,
    sliderClass: String,
    switchClass: {
      type: String,
      default: 'a-toggle-switch-center-primary'
    },
    text: {
      type: String,
      default: ''
    },
    value: [Boolean, Number]
  },

  methods: {
    updateValue (event) {
      if (this.method) {
        this.$emit(this.method, { id: this.elementId, state: +event.target.checked })
      } else {
        this.$emit('input', +event.target.checked)
      }
    }
  }
}
</script>
